const icons = import.meta.glob('../images/icons/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

export default function icon(name) {
  const url = icons[`../images/icons/${name}`];

  if (!url) {
    throw new Error(`Unknown icon: ${name}`);
  }

  return url;
}
